// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 3H23V18H1V3ZM0 19H24V21H0V19Z"}}]};

const LaptopFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'laptop-filled',
    ref,
    icon: element,
  },
));

LaptopFilledIcon.displayName = 'LaptopFilledIcon';

export default LaptopFilledIcon;
